<template>
    <div class="page1">

        <!-- <Header/> -->
        <div>

            <div class="page-header">
                <div class="container">
                    <div class="page-header__logo text-start pt-4 pb-3">
                        <img src="./assets/logo.png" class="mw-100" alt="">
                    </div>
                    <div class="page-headline text-center">
                        <img src="./assets/kiem-tra-nang-luc-headline.png" class="mw-100" alt="">
                    </div>
                </div>
            </div>

            <div class="page-middle">
                <div class="container">
                    <div class="intro-teacher">
                        <div class="box-border">
                            <span>Trải nghiệm bài thi kiểm tra năng lực tiếng Anh chuẩn xác nhất được thiết kế bởi đội ngũ thầy cô, chuyên gia trong và ngoài nước.</span>
                        </div>
                    </div>
                </div>
            </div>

            <div style="padding-bottom:80px; z-index: 2;" class="position-relative">
                
                <ContactForm
                v-model="form"
                :step="form.step"
                @change-step="ChangeStep"
                />

                <!-- error message -->
                <div v-if="error.msg">
                    <div class="container">
                        <div class="text-center">
                            <p class="text-danger h4 bold">{{ error.msg }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- error message end -->

            <div class="page-footer">
                <div class="footer__pc">
                    <img class="footer__cloud cloud-1" src="./assets/cloud.png" alt="">
                    <img class="footer__cloud cloud-2" src="./assets/cloud2.png" alt="">
                </div>

                <div class="footer__mobile">
                    <div class="footer__cloud cloud-1">
                        <img class="" src="./assets/cloud.png" alt="">
                        <img class="lan-1" src="./assets/lan-left.png" alt="">
                    </div>

                    <div class="footer__cloud cloud-2">
                        <img class="" src="./assets/cloud2.png" alt="">
                        <img class="lan-2" src="./assets/lan-right.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>

import ContactForm from '@/components/ContactForm.vue'

// mixins import
import Page1 from '@/plugins/TestPlugin/mixins/page1'

export default {
    mixins: [Page1],
    created() {
    },
    components: {
        ContactForm
    },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    beforeUpdate() {
    },
    destroyed() {
    },
    updated() {
    }

}
</script>


<style lang="scss">

input:-webkit-autofill,
input:-webkit-autofill:focus {
    background-image: url(./assets/input-pg.svg) !important;
    background-color: unset;
}

#placement-test-newyear-layout {

    .btn-next {
        background-image: url(./assets/btn-next-pg.png);
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        color: transparent;
        width: 140px;
        height: 55px;
    }

    .page1 {
        .btn-custom.btn-success {
            background-color: transparent;
            box-shadow: none;
            border: 0;
        }
    }
    
    .form-info.xmas .form-group > div {
        
        position: relative;

        input {
            background-image: url(./assets/input-pg.svg);
            background-repeat: repeat-x;
            background-size: contain;
            border-radius: 0;
        }

        &::before {
            content: '';
            display: block;
            width: 30px;
            height: 76px;
            background-image: url(./assets/input-left.png);
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: -14px;
            left: -26px;
            z-index: 1000;
        }

        &::after {
            content: '';
            display: block;
            width: 30px;
            height: 76px;
            background-image: url(./assets/input-right.png);
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            top: -14px;
            right: -26px;
            z-index: 1000;
        }
    }
}

</style>

<style lang="scss" scoped>

$sc1000: 1000px;

@mixin sc1000 {
    @media (max-width: #{$sc1000}) {
        @content;
    }
}

.page1 {

    .page-headline {
        margin: auto;
        margin-top: -40px;
        position: relative;
        width: fit-content;

        @include sc1000 {
            margin-top: 10px;
        }

        &::before {
            content: "";
            display: block;
            background-image: url(./assets/kiem-tra-nang-luc_item-left.png);
            background-repeat: no-repeat;
            background-size: contain;
            width: 109px;
            height: 107px;
            position: absolute;
            left: 0px;
            bottom: -20px;

            @include sc1000 {
                display: none;
            }
        }

        &::after {
            content: "";
            display: block;
            background-image: url(./assets/kiem-tra-nang-luc_item-right.png);
            background-repeat: no-repeat;
            background-size: contain;
            width: 302px;
            height: 211px;
            position: absolute;
            right: -180px;
            bottom: -50px;
            
            @include sc1000 {
                display: none;
            }
        }
    }

}



.page1 {
    background-image: url(./assets/bg.jpg);
    min-height: 100vh !important;
    background-size: cover;
    background-position: bottom center;
    // height: 100vh !important;
    background-attachment: fixed;

}

.page-header {
    position: relative;

    .page-header__logo {
        @include sc1000 {
            text-align: center !important;
        }
    }
}

.page-footer {


    .footer__pc {

        position: fixed;
        width: 100%;
        bottom: 0;
        height: 250px;
        z-index: 1;

        .footer__cloud {
            @include sc1000 {
                display: none;
            }
        }

        .cloud-1 {
            position: absolute;
            left: -280px;
        }

        .cloud-2 {
            position: absolute;
            right: -280px;
        }
    }

    .footer__mobile {
        display: none;
        height: 300px;
        margin-top: -80px;
        width: 100%;
        position: relative;
        overflow: hidden;

        .footer__cloud {
            position: relative;
            min-width: 500px;
            bottom: -100px;
        }

        @include sc1000() {
            display: flex;
            justify-content: space-around;
        }

        .lan-1 {
            height: 250px;
            top: -60px;
            position: absolute;
            right: -40px;
        }

        .lan-2 {
            height: 250px;
            top: -60px;
            position: absolute;
            left: -40px;
        }
        
    }
    

}

.page-middle {

    margin-top: 25px;
    .intro-teacher {
        z-index: 1;
        position: relative;
        text-align: center;
        max-width: 800px;
        margin: auto;
        background: rgb(242,184,149);
        background: linear-gradient(0deg, rgba(242,184,149,1) 0%, rgb(253, 231, 201) 100%);
        padding: 5px;
        border-radius: 20px;
        border: 2px solid #000000;
        box-shadow: 0px 0px 0px 5px #fff;


        .box-border {
            padding: 15px;
            background: rgb(242,184,149);
            background: linear-gradient(0deg, rgba(242,184,149,1) 0%, rgb(253, 231, 201) 100%);
                
            border-radius: 15px;
            border: 2px solid #1c5faa;

            
            span {
                font-size: 1.3rem;
                color: #840022;
                font-weight: 900;

                @include sc1000 {
                    font-size: 1rem;
                }
            }
        }
    }
}

.invalid-feedback {
    color: #ffc0c6;
}

.form-info {

    position: relative;

    @include sc1000 {
        padding-left: 20px;
        padding-right: 20px;
    }
    
    .lan-1 {
        position: absolute;
        left: -115%;
        bottom: -30px;
        
        @include sc1000 {
            display: none;
        }
    }

    .lan-2 {
        position: absolute;
        right: -115%;
        bottom: -30px;

        @include sc1000 {
            display: none;
        }
    }


    .form-group {

        margin-bottom: 20px;
        margin-top: 36px;

        div {

            input {
                border: none;
                margin: 0;
                box-shadow: none;
                z-index: 999;
                position: relative;
                background-color: transparent;               
            }
        }
    }

}

.title-form {
    
    h5{
        text-align: center;
        color: #fff;
        font-weight: 500;
        font-size: 1.3rem;
    }
}


</style>

<style scoped>

.form-info{
    width: 45%;
    max-width: 450px;
    margin: auto;
}
.form-control {
    border-radius: 15px;
    color: #0158a8;
    line-height: 1.5;
    margin-bottom: 20px;
    font-weight: 600;
    box-shadow: 0px 4px 3px #1b96f2;
    height: 50px;
    padding: 15px;
}
.form-control::-webkit-input-placeholder {
    color: #0158a8;
}
.input-group-5{
    display: flex;
    align-items: center;
    border-radius: 15px;
    color: #0158a8;
    margin-bottom: 18px;
    font-weight: 600;
    box-shadow: 0px 4px 3px #1b96f2;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;height: 50px;
    padding: 15px;
    appearance: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-control-input {
    top: 10px;
}
.checkbox {
    display:flex;
    flex-direction:column;
    align-items: center;
    margin-left: 40px;
}

@media only screen and (max-width: 1200px){
    .form-info {
        width: 50%;
    }
}

@media only screen and (max-width: 992px){
    .form-info {
        width: 65%;
    }
}

@media only screen and (max-width: 768px){

    .form-info {
        width: 100%;
    }
    .learn-check {
        margin: 0 0px 0 10px;
    }
    .checkbox{
        margin-left: 10px;
    }
    .title-form h5 {
        font-size: 18px;
    }
    .input-group-5{
        height: auto;
        display: block;
        text-align: center;
        box-shadow: 0px 5px 10px #bac1c5;
        z-index: 9;
        position: relative;
    }
    .learn-check {
        padding-left: 0px;
        display: block;
        margin-bottom: 20px;
    }
    .input-group-5 .checkbox{
        display: inline-block !important;
    }
    .input-group-5 .checkbox:last-child{
        margin-left: 30px;
    }
    .cloudy-pg1{
        bottom: -160px;
    }
    .btn-custom.btn-success{
        font-size: 25px;
    }
}
@media only screen and (min-width: 1024px)  and (max-width: 1400px){
    .cloudy-pg1{
        bottom: -220px;
    }
}


@media (max-width: 680px){
    form.qanda {
        width: unset;
    }

    form.qanda .custom-radio {
        margin-top: 10px;
    }
}

</style>